<mat-dialog-content class="customer-dialog">
<div class="search-container">
    <mat-form-field >
      <mat-label>User Code</mat-label>
      <input matInput [(ngModel)]="userID" (keyup)="retriveUsersLookup()">
    </mat-form-field>

    <mat-form-field  >
      <mat-label>User Name</mat-label>
      <input matInput [(ngModel)]="userName" (keyup)="retriveUsersLookup()">
    </mat-form-field>

  </div>

  <!-- Table -->
  <div class="table-container">
    <table class="customer-table">
      <thead>
        <tr matTooltip="Click for sorting" style="cursor: ns-resize;">
        <th style="width: 30%;">User ID</th>
        <th style="width: 100%;">User Name</th>
        <th style="width: 20%;">Choose</th>
        </tr>

      </thead>
      <tbody>
        <tr *ngFor="let us of usersList; let i = index">
        <td>{{us.userID}}</td>
        <td>{{us.userName}}</td>
          <td>
            <button mat-raised-button style="color: white;background-color: rgb(0, 0, 128);"
                    (click)="SelectUsers(us)">{{'Select' | translate}}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>



  </mat-dialog-content>
